// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DetectBrowser = require("detect-browser");
let EdgeSvg = require("./images/edge.svg");
let JsxRuntime = require("react/jsx-runtime");
let ChromeSvg = require("./images/chrome.svg");
let SafariSvg = require("./images/safari.svg");
let FirefoxSvg = require("./images/firefox.svg");

let chrome = ChromeSvg;

let safari = SafariSvg;

let firefox = FirefoxSvg;

let edge = EdgeSvg;

let Icons = {
  chrome: chrome,
  safari: safari,
  firefox: firefox,
  edge: edge
};

let DetectBrowser$1 = {};

let browsers = [
  {
    title: "Google Chrome",
    icon: chrome,
    url: "https://www.google.com/chrome/"
  },
  {
    title: "Apple Safari",
    icon: safari,
    url: "https://www.apple.com/safari/"
  },
  {
    title: "Mozilla Firefox",
    icon: firefox,
    url: "https://www.mozilla.org/en-US/firefox/new/"
  },
  {
    title: "Microsoft Edge",
    icon: edge,
    url: "https://www.microsoft.com/en-US/windows/microsoft-edge"
  }
];

let b = DetectBrowser.detect();

let isWindows;

isWindows = (b == null) ? false : b.os.includes("Windows");

let browsersFiltered = browsers.filter(item => {
  if (isWindows) {
    return item.title !== "Apple Safari";
  } else {
    return item.title !== "Microsoft Edge";
  }
});

function renderItem(b) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx("img", {
          className: "block w-[54px] h-[54px]",
          title: b.title,
          alt: b.title,
          src: b.icon
        }),
        className: "block rounded-full p-[13px] bg-white",
        href: b.url
      }),
      JsxRuntime.jsx("a", {
        children: b.title,
        className: "block mt-4 text-lg font-light text-tan-blue-900 hover:no-underline",
        href: b.url
      })
    ],
    className: "flex flex-col items-center shrink-0 px-5 transition-transform duration-150 hover:scale-[1.15]"
  });
}

function GreatBrowsers(props) {
  let __title = props.title;
  let title = __title !== undefined ? __title : "Download the latest version of one of these great browsers to use TAN:";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: title,
        className: "text-zinc-800 text-[24px] leading-[1.5] text-center mb-[40px] font-light"
      }),
      JsxRuntime.jsx("div", {
        children: browsersFiltered.map(renderItem),
        className: "flex justify-center items-center"
      })
    ]
  });
}

let make = GreatBrowsers;

exports.Icons = Icons;
exports.DetectBrowser = DetectBrowser$1;
exports.browsers = browsers;
exports.isWindows = isWindows;
exports.browsersFiltered = browsersFiltered;
exports.renderItem = renderItem;
exports.make = make;
/* chrome Not a pure module */
